// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer___mXpK","mobile":"Footer_mobile__TYNqJ"};